
import Vue, { ComponentOptions, VNode, VueConstructor } from 'vue';
import Component from 'vue-class-component';
import { GraphRegistry, GraphSpec } from '@/graphregistry';
import { GraphView } from '@/graph/graphview';
import { Navigator } from '../views/navigator'
import { GraphParser } from '@/graph/graphparser';
import { Generator } from '@/graph/generator';

type ColorStyle = "Mono" | "Colors1" | "Colors2" 
type Shaping = "None" | "Parallelogram" | "Pentagon" | "Box" | "Mixed"
type Direction = "TopDown" | "LeftRight"


@Component({
    template: `
    <div class="column-container stretch grow height100" >
        <h2>Graphviewer</h2>
        <div class="grow column-container">
            <p>Enter your own gv-file and ... <span style="padding-left: 1rem;"><v-btn small @click="onRender()">Render it</v-btn></span>
            </p>
            <div class="row-container grow">
                <div class="column-container" style="flex: 0 0 30%;">
                    <v-textarea filled v-model="source" rows="10" style="flex: 1;" @input="onSourceChanged()"></v-textarea>
                    <div class="row-container">
                        <v-select :items="directions" v-model="direction" label="Direction" @change="rehashPreview()" ></v-select>
                        <div style="width: 1rem;"></div>
                        <v-select :items="colorStyles" v-model="colorStyle" label="Style" @change="rehashPreview()" ></v-select>
                        <div style="width: 1rem;"></div>
                        <v-select :items="shapings" v-model="shaping" label="Shapes" @change="rehashPreview()" ></v-select>
                    </div>
                    <p>See the examples
                        <ul style="padding-left: 3rem;">
                            <li v-for="(spec, index) in getSpecs()" @click="onGraphSpec(spec, index)"><a>{{spec.description}}</a></li>
                        </ul>
                    </p>
                </div>
                <div class="column-container" style="flex: 1; margin-left: 8px; ">
                    <component style="flex: 1; min-width: 100px;" :ref="'graphViewPreview'" v-bind:is="graphViewPreview" v-bind:svgraw="svgraw"></component>
                </div>
            </div>
        </div>
        <v-dialog v-model="productionDialog" max-width="290">
            <v-card>
                <v-card-title class="headline">Sorry, not available</v-card-title>
                <v-card-text>Alas, this feature is not available in this deployment.</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click="productionDialog = false">Dismiss</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
`,
})
export class Home extends Vue {

    graphViewPreview: VueConstructor = null
    svgraw = ""
    recentgv = ""
    productionDialog = false
    source = ""

    direction : Direction = "TopDown"
    directions : Direction[] = [ "TopDown", "LeftRight"]

    colorStyle : ColorStyle = "Colors1"
    colorStyles : ColorStyle[] = [ "Mono", "Colors1", "Colors2" ]

    shaping : Shaping = "Box"
    shapings : Shaping[] = [ "None", "Parallelogram", "Pentagon", "Box", "Mixed" ]


    created() {
    }

    async mounted() {
        let s = "a b\na c\n"
        s = `
        texas bowl
cotton bowl
beard aabottom
cotton texas
aabottom tush
tush dallas
texas hollywood
billy dallas
        `
        s = `
        texas bowl
cotton bowl
beard aabottom
cotton texas
aabottom tush
tush dallas
texas hollywood
billy dallas
a b
a c
billy a
a cotton
a beard
a d

        `
        s = "a b\na c\n"
        s = `
a b
a c
0 1§
k 1§
l 0§
hans a°
martin hans°
joe hauser°
martin joe°
martin b#
zz martin°
0 ll°
i 100°
l 100*
a zz
`
        this.source = s.trim() + "\n"
        /*
        let gv = await this.convertSourceToGv()
        this.svgraw = await Generator.instance.generateSvg(gv)
        */
       this.graphViewPreview = GraphView
       this.$nextTick(() => {
           this.rehashPreview()
       })
    }

    getSpecs() {
        return GraphRegistry.instance.getSpecs()
    }

    getGraphViewPreview(): GraphView {
        return this.$refs.graphViewPreview as GraphView
    }

    onGraphSpec(spec: GraphSpec, index: number) {
        let n = new Navigator({})
        this.$router.push({
            path: "/navigator/" + index,
        })
    }

    onRender() {
        this.productionDialog = true
    }

    onSourceChanged() {
        this.rehashPreview().then(() => { })
    }

    async convertSourceToGv(): Promise<string> {
        let parser = new GraphParser(this.source)
        parser.parse()
        let gv = `digraph G {`
        if (this.direction == "LeftRight") {
            gv += `rankdir=LR;\n`
        }
        let bgcolors : string[] = []
        let fgcolors : string[] = []
        if (this.colorStyle == "Colors1") {
            bgcolors = [
                '#eed7db',
                '#d6b7b1',
                '#ae8094',
                '#85506e',
                '#58443e',
            ]
            fgcolors = [
                '#000000',
                '#000000',
                '#000000',
                '#000000',
                '#ffffff',
            ]
        } else if (this.colorStyle == "Colors2") {
            bgcolors = [
                '#e5b163',
                '#d4b68e',
                '#f0eef4',
                '#563c2d',
                '#97aea0',
            ]
            fgcolors = [
                '#000000',
                '#000000',
                '#000000',
                '#ffffff',
                '#000000',
            ]
        }
        let shapes : string[] = []
        if (this.shaping == "Box") {
            shapes = [ 'box']
        } else if (this.shaping == "Parallelogram") {
            shapes = [ 'parallelogram']
        } else if (this.shaping == "Pentagon") {
            shapes = [ 'pentagon']
        } else if (this.shaping == "Mixed") {
            shapes = [ 'box', 'parallelogram', 'pentagon' ]
        }
        if (shapes.length > 0) {
            let colorClause = bgcolors.length == 1 ? `fillcolor="#d62728", ` : ""
            gv += `  node [style="filled", ${colorClause} fontcolor="#000000", shape="${shapes[0]}"];` + "\n"
        }
        let nodes = new Set<string>()
        for (let edge of parser.edges) {
            nodes.add(edge.a)
            nodes.add(edge.b)
        }
        //console.log("colorStype=" + this.colorStyle)
        //console.log("shaping=" + this.shaping)
        //console.log("colors=" + JSON.stringify(colors))
        //console.log("shapes=" + JSON.stringify(shapes))
        if (shapes.length > 1 || bgcolors.length > 1) {
            let shapeindex = 0
            let colorindex = 0
            for (let node of Array.from(nodes)) {
                let colorClause = this.shaping != "None" && bgcolors.length > 1  
                    ? `fillcolor="${bgcolors[(colorindex)%bgcolors.length]}", fontcolor="${fgcolors[(colorindex)%fgcolors.length]}", ` 
                    : ""
                let shapeClause = shapes.length > 1 ? `shape="${shapes[(shapeindex++)%shapes.length]}" ` : ""
                colorindex++;
                let shape = parser.shapes.get(node)
                if (shape) {
                    shapeClause = `shape="${shape.name}" `
                }
                gv += `  "${node}" [ ${colorClause}${shapeClause}];` + "\n"
            }
        }
        for (let edge of parser.edges) {
            gv += `  "${edge.a}" -> "${edge.b}";` + "\n"
        }
        gv += `}`
        //console.log(gv)
        return gv
    }

    async rehashPreview(): Promise<any> {
        console.log("dir " + this.direction)
        let gv;
        if (this.source && (this.source.trim().startsWith("graph")
            || this.source.trim().startsWith("digraph"))) {
            gv = this.source
        } else {
            gv = await this.convertSourceToGv()
        }
        gv = gv?.trim()
        if (this.recentgv == gv) {
            return
        }
        this.recentgv = gv?.trim()
        let newsvg = await Generator.instance.generateSvg(gv)
        let g = this.getGraphViewPreview()
        g.inputSvg = newsvg
        g.rehashRawSvg(() => {
            g.showAll(true)
            setTimeout(() => {
                g.showAll(true)
            }, 250)
        })
    }

}

